'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxForm = require('redux-form');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactIntlTelInput = require('react-intl-tel-input');var _reactIntlTelInput2 = _interopRequireDefault(_reactIntlTelInput);
var _publish = require('../../../../redux/modules/normalizers/publish');var _publish2 = _interopRequireDefault(_publish);
var _userAuthentication = require('../../../../redux/modules/userAuthentication');

var _AddNewStaffForm = require('./AddNewStaffForm.scss');var styles = _interopRequireWildcard(_AddNewStaffForm);
var _reduxFormValidators = require('../../../../helpers/reduxFormValidators');
var _OMButtonWithPreloader = require('../../../../components/OMComponents/OMButtonWithPreloader/OMButtonWithPreloader');var _OMButtonWithPreloader2 = _interopRequireDefault(_OMButtonWithPreloader);
var _constants = require('../../../../constants');
var _validate = require('./validate');var _validate2 = _interopRequireDefault(_validate);
var _Constants = require('../../Constants');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Styles
var AddNewStaffForm = function (_Component) {_inherits(AddNewStaffForm, _Component);
  function AddNewStaffForm(props) {_classCallCheck(this, AddNewStaffForm);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.






    onSelectFlag = function (_, countryData) {
      _this.setState({ countryData: countryData.dialCode });
    };_this.

    getMaxCount = function (fieldName) {var
      metaStaff = _this.props.metaStaff;

      switch (fieldName) {
        case _Constants.FIELD_NAMES.PUBLISH_LIMIT:
          return metaStaff.canAddProperties;
        case _Constants.FIELD_NAMES.TOP_PROMOTION_LIMIT:
          return metaStaff.canAddTopPromotions;
        case _Constants.FIELD_NAMES.COLOR_PROMOTION_LIMIT:
          return metaStaff.canAddColorPromotions;
        default:
          return 0;}

    };_this.

    submitForm = function (values) {var _this$props =
      _this.props,userToken = _this$props.userToken,addUser = _this$props.addUser;
      var countryData = _this.state.countryData.replace(/\+/g, '');
      var phone = countryData === _constants.israelCode && values.phone.startsWith('0') ?
      values.phone.slice(1) :
      values.phone;

      var data = {
        publish_limit: values.publish_limit,
        top_promotion_limit: values.top_promotion_limit || '0',
        color_promotion_limit: values.color_promotion_limit || '0',
        phone: '' + countryData + phone };


      addUser({ data: data, token: userToken }).then(function () {return (0, _userAuthentication.authUserByToken)(userToken);});
    };_this.

    handleSubmit = function (evt) {
      _this.props.handleSubmit(_this.submitForm)(evt);
      return true;
    };_this.

    validatePhoneNumber = function () {var phoneNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var number = phoneNumber.toString().replace(/\D/g, '');
      var isValid = !!number && number.length >= 9 && number.length <= 15;

      _this.setState({ phoneNumberIsInvalid: !isValid });
      return !isValid;
    };_this.

    renderPhoneNumber = function (_ref) {var input = _ref.input,_ref$meta = _ref.meta,error = _ref$meta.error,touched = _ref$meta.touched;return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.inputPhone, { 'has-error': error && touched }) },
          _react2.default.createElement(_reactIntlTelInput2.default, {
            autoPlaceholder: false,
            nationalMode: false,
            containerClassName: (0, _classnames2.default)('intl-tel-input', styles.countrySelect),
            inputClassName: 'form-control phone-input',
            fieldName: 'phone_number',
            value: input.value,
            preferredCountries: _constants.PREFERRED_COUNTRIES,
            onPhoneNumberChange: function onPhoneNumberChange(_, value) {
              input.onChange(value);
            },
            onSelectFlag: _this.onSelectFlag,
            useMobileFullscreenDropdown: false,
            separateDialCode: true }),

          error && touched &&
          _react2.default.createElement('span', { className: styles.required },
            _this.props.translate('errorFieldMessages', 'phone-number'))));};_this.





    renderInput = function (_ref2) {var input = _ref2.input,label = _ref2.label,placeholder = _ref2.placeholder,type = _ref2.type,_ref2$meta = _ref2.meta,touched = _ref2$meta.touched,error = _ref2$meta.error,active = _ref2$meta.active;
      var maxCount = _this.getMaxCount(input.name);

      return (
        _react2.default.createElement('span', null,
          _react2.default.createElement('input', _extends({
            className: (0, _classnames2.default)({ 'has-error': error && !active && touched, touched: touched }, 'form-control') },
          input, {
            placeholder: placeholder || label,
            type: type })),

          _react2.default.createElement('div', { className: styles.leftWrapper },
            _react2.default.createElement('p', { className: styles.left }, _this.props.translate('myStaff', 'left')),
            _react2.default.createElement('p', { className: styles.count }, maxCount)),

          touched && error &&
          _react2.default.createElement('span', { className: styles.required },
            _this.props.translate('errorFieldMessages', error))));




    };_this.state = { phoneNumberIsInvalid: false, countryData: '' + _constants.israelCode };return _this;}AddNewStaffForm.prototype.

  render = function render() {var _this2 = this;var _props =
    this.props,translate = _props.translate,addUserLoading = _props.addUserLoading,isRtl = _props.isRtl;

    return (
      _react2.default.createElement('div', { className: styles.formWrapper },
        _react2.default.createElement('div', { className: styles.formHead },
          _react2.default.createElement('p', { className: styles.title }, translate('myStaff', 'addNewStaff')),
          _react2.default.createElement('p', { className: styles.subTitle }, translate('myStaff', 'addNewStaffDescription'))),

        _react2.default.createElement('form', { noValidate: 'noValidate' },
          _react2.default.createElement('div', { className: styles.rowBlock },
            _react2.default.createElement('div', { className: styles.title },
              translate('editOwner', 'phone_number'),
              _react2.default.createElement('span', { className: 'req' }, '*')),

            _react2.default.createElement(_reduxForm.Field, {
              name: 'phone',
              type: 'text',
              translate: translate,
              isRtl: isRtl,
              component: this.renderPhoneNumber,
              validate: this.validatePhoneNumber })),


          _react2.default.createElement('p', { className: styles.textInformation }, translate('myStaff', 'assignHighlights')),
          _react2.default.createElement('div', { className: styles.fieldsWrapper },
            Object.values(_Constants.FIELD_NAMES).map(function (field) {return (
                _react2.default.createElement('div', { key: field, className: styles.fieldWrapper },
                  _react2.default.createElement('p', { className: styles.name },
                    translate('myStaff', field),
                    field === _Constants.FIELD_NAMES.PUBLISH_LIMIT && _react2.default.createElement('span', { className: 'req' }, '*')),

                  _react2.default.createElement(_reduxForm.Field, {
                    name: field,
                    required: field === _Constants.FIELD_NAMES.PUBLISH_LIMIT,
                    component: _this2.renderInput,
                    type: 'tel',
                    inputmode: 'numeric',
                    pattern: '[0-9]*',
                    normalize: _publish2.default.numbers })));})),




          _react2.default.createElement('div', { className: styles.btnSubmit, type: 'submit' },
            _react2.default.createElement(_OMButtonWithPreloader2.default, {
              onClick: this.handleSubmit,
              showPreloader: addUserLoading,
              innerText: translate('myStaff', 'add') })))));





  };return AddNewStaffForm;}(_react.Component);


AddNewStaffForm.propTypes = {
  translate: _propTypes2.default.func.isRequired,
  handleSubmit: _propTypes2.default.func.isRequired,
  addUser: _propTypes2.default.func.isRequired,
  userToken: _propTypes2.default.string.isRequired,
  addUserLoading: _propTypes2.default.bool.isRequired,
  isRtl: _propTypes2.default.bool.isRequired,
  metaStaff: _propTypes2.default.object.isRequired };exports.default =


(0, _reduxForm.reduxForm)({
  form: 'add-my-staff-user',
  validate: _validate2.default })(
AddNewStaffForm);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyStaffContainer/components/AddNewStaffForm/AddNewStaffForm.js
// module id = 3016
// module chunks = 0